import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getExecutorWiresPath = () => urlHelper('/executor/wires');
